"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = exports.renderLoading = exports.renderDocumentResultHead = exports.renderDocumentResult = exports.renderDocumentCard = void 0;
var DocumentAction_1 = require("@/pages/document/actions/DocumentAction");
var EformTypes_1 = require("@/pages/document/states/EformTypes");
var classNames = require("classnames");
var React = require("react");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var format_1 = require("@/utils/format");
var EformStatus_1 = require("@/pages/document/states/EformStatus");
var ResultPagination_1 = require("@/pages/search/components/ResultPagination");
var DocumentSortEnum_1 = require("@/pages/document/states/DocumentSortEnum");
var mapStateToProps = function (state) { return (__assign(__assign({}, state.document), { currentUrl: '/mydocuments/pending/1', prefix: 'HK$', lang: state.layout.language.languages.find(function (it) { return it.id === state.layout.language.current; }).code1 })); };
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    onChangePage: function (page) { return dispatch(DocumentAction_1.default.onChangePage(page)); },
    onExpandClicked: function (i) { return dispatch(DocumentAction_1.default.onMoreClicked(i)); },
    onViewClickedByDocumentPath: function (key) { return dispatch(DocumentAction_1.default.onViewClickedByDocumentPath(key)); },
    onSortLabelClick: function () { return dispatch(DocumentAction_1.default.onSortLabelClick()); },
    onSortChanged: function (sort) { return dispatch(DocumentAction_1.default.onSortChanged(sort)); },
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var formStatusToString = function (status, t) {
    switch (status) {
        case EformStatus_1.EformStatus.NOT_STARTED: return t.notStarted;
        case EformStatus_1.EformStatus.WAITING_ME: return t.pendingSignature;
        case EformStatus_1.EformStatus.WAITING_OTHERS: return t.pendingOthers;
        case EformStatus_1.EformStatus.COMPLETED: return t.completed;
    }
};
var formStatusToAction = function (status, t) {
    switch (status) {
        case EformStatus_1.EformStatus.NOT_STARTED: return null;
        case EformStatus_1.EformStatus.WAITING_ME: return t.reviewAndSign;
        case EformStatus_1.EformStatus.WAITING_OTHERS: return null;
        case EformStatus_1.EformStatus.COMPLETED: return t.view;
    }
};
var formStatusToButtonClass = function (status) {
    var classes = ['o-btn', 'o-btn--primary', 'u-upper'];
    switch (status) {
        case EformStatus_1.EformStatus.NOT_STARTED: {
            classes.push('o-btn--disabled');
            break;
        }
        case EformStatus_1.EformStatus.WAITING_ME: {
            classes.push('o-btn--primary-flat');
            break;
        }
        case EformStatus_1.EformStatus.WAITING_OTHERS:
            {
                classes.push('o-btn--disabled');
                break;
            }
            ;
        case EformStatus_1.EformStatus.COMPLETED: {
            break;
        }
    }
    var classStr = classNames(classes);
    return classStr;
};
var formStatusToIndicatorClass = function (status) {
    var classes = ['c-document__sign-status-indicator'];
    switch (status) {
        case EformStatus_1.EformStatus.NOT_STARTED:
            {
                break;
            }
            ;
        case EformStatus_1.EformStatus.WAITING_ME: {
            classes.push('c-document__sign-status-indicator--pending-me');
            break;
        }
        case EformStatus_1.EformStatus.WAITING_OTHERS:
            {
                classes.push('c-document__sign-status-indicator--pending-others');
                break;
            }
            ;
        case EformStatus_1.EformStatus.COMPLETED: {
            classes.push('c-document__sign-status-indicator--completed');
            break;
        }
    }
    var classStr = classNames(classes);
    return classStr;
};
var isNetSizeToUnitStr = function (t, isNetSize) {
    if (isNetSize)
        return t.sfS;
    return t.sfG;
};
var renderDocumentProperty = function (props) { return function (property, i) {
    var saleRent = property.type === SfilterTypeGroup_1.ListingPurposeType.Rent ? 'rent' : 'sale';
    var buildingName = format_1.default.normalize(property.buildingName);
    var detailsPageUrl = "/" + props.lang + "/property/" + saleRent + "/" + buildingName + "/" + property.property_id;
    var noImageUrl = '/res/img/nopic.jpg';
    return (React.createElement("div", { key: i, className: "c-document__card-property" },
        React.createElement("div", { className: "c-document__card-property-image" }, property.imageUrl ? React.createElement("img", { src: property.imageUrl, alt: "" }) : React.createElement("img", { src: noImageUrl, alt: "" })),
        React.createElement("div", { className: "c-document__card-property-info" },
            React.createElement("a", { href: detailsPageUrl, className: "c-document__card-property-title" }, property.title),
            React.createElement("div", { className: "c-document__card-property-config" },
                property.size > 0 ? (React.createElement("div", { className: "c-document__card-property-size" },
                    React.createElement("div", { className: "c-document__card-property-value" }, format_1.default.comma(property.size)),
                    React.createElement("div", { className: "c-document__card-property-unit" }, isNetSizeToUnitStr(props.t, property.isNetSize)))) : null,
                React.createElement("div", { className: "c-document__card-property-beds" },
                    React.createElement("div", { className: "c-document__card-property-value" }, property.beds),
                    React.createElement("div", { className: "c-document__card-property-unit" }, props.t.beds)),
                property.bath > 0 ? (React.createElement("div", { className: "c-document__card-property-baths" },
                    React.createElement("div", { className: "c-document__card-property-value" }, property.bath),
                    React.createElement("div", { className: "c-document__card-property-unit" }, props.t.baths))) : null)),
        React.createElement("div", { className: "c-document__card-property-price" }),
        property.price ? (React.createElement("div", { className: "c-document__card-property-price-box" },
            React.createElement("div", { className: "c-document__card-property-price-label" }, props.t.askingPrice),
            React.createElement("div", { className: "c-document__card-property-price" }, format_1.default.currencyFull(property.price, props.prefix)),
            React.createElement("div", { className: "c-document__card-property-price--mobile" }, format_1.default.currencyShort(property.price, props.prefix)))) : null));
}; };
var renderDocumentCard = function (props) { return function (form, i) {
    var onExpandClick = function (event) {
        event.stopPropagation();
        props.onExpandClicked(i);
    };
    var cardPropertiesClasses = classNames(['c-document__card-properties', { 'u-hidden': !form.isExpanded }]);
    var formTypeToBackground = function (type) {
        var _a, _b;
        return (_b = (_a = [
            { type: EformTypes_1.EformTypes.EAA_FORM_1, color: '#fff' },
            { type: EformTypes_1.EformTypes.EAA_FORM_2, color: '#fff' },
            { type: EformTypes_1.EformTypes.EAA_FORM_3, color: '#ffffef' },
            { type: EformTypes_1.EformTypes.EAA_FORM_4, color: '#fff3fa' },
            { type: EformTypes_1.EformTypes.EAA_FORM_5, color: '#ffffef' },
            { type: EformTypes_1.EformTypes.EAA_FORM_6, color: '#fff3fa' },
        ].find(function (it) { return it.type === type; })) === null || _a === void 0 ? void 0 : _a.color) !== null && _b !== void 0 ? _b : '#fff';
    };
    var formStatusToBorderColor = function (status) {
        var _a, _b;
        return (_b = (_a = [
            { type: EformStatus_1.EformStatus.NOT_STARTED, color: '#fff' },
            { type: EformStatus_1.EformStatus.WAITING_ME, color: '#FAC710' },
            { type: EformStatus_1.EformStatus.WAITING_OTHERS, color: '#fff' },
            { type: EformStatus_1.EformStatus.COMPLETED, color: '#fff' },
        ].find(function (it) { return it.type === status; })) === null || _a === void 0 ? void 0 : _a.color) !== null && _b !== void 0 ? _b : '#fff';
    };
    var formStatusToBorderWidth = function (status) {
        var _a, _b;
        return (_b = (_a = [
            { type: EformStatus_1.EformStatus.NOT_STARTED, width: 0 },
            { type: EformStatus_1.EformStatus.WAITING_ME, width: 4 },
            { type: EformStatus_1.EformStatus.WAITING_OTHERS, width: 0 },
            { type: EformStatus_1.EformStatus.COMPLETED, width: 0 },
        ].find(function (it) { return it.type === status; })) === null || _a === void 0 ? void 0 : _a.width) !== null && _b !== void 0 ? _b : 0;
    };
    var renderCardAction = function (props, form) {
        var actionText = formStatusToAction(form.status, props.t);
        var onViewClicked = function (event) {
            event.stopPropagation();
            props.onViewClickedByDocumentPath(form.documentPath);
        };
        if (!actionText)
            return null;
        if (form.documentPath)
            return (React.createElement("a", { onClick: onViewClicked, className: formStatusToButtonClass(form.status) }, actionText));
        if (form.signingUrl)
            return (React.createElement("a", { href: form.signingUrl, target: "_blank", className: formStatusToButtonClass(form.status) }, actionText));
    };
    return (React.createElement("div", { key: i, className: "c-document__card", style: { borderColor: formStatusToBorderColor(form.status), borderLeftWidth: formStatusToBorderWidth(form.status) } },
        React.createElement("div", { className: "c-document__card-body" },
            React.createElement("div", { className: "c-document__card-info" },
                form.caption_1 ? React.createElement("div", { className: "c-document__caption-top" }, form.caption_1) : null,
                React.createElement("div", { className: "c-document__title" }, form.title),
                React.createElement("div", { className: "c-document__tags" },
                    React.createElement("div", { className: "c-document__tag", style: { backgroundColor: formTypeToBackground(form.type) } }, format_1.default.print(props.t.form, ["" + form.type]))),
                React.createElement("a", { onClick: onExpandClick, style: { userSelect: 'none', cursor: 'pointer' }, className: "c-document__more" }, format_1.default.print(form.properties.length > 1 ? props.t.viewProperties : props.t.viewProperty, ["" + (form.properties.length > 1 ? form.properties.length : (form.properties.length === 1 ? form.properties[0].title : ''))]))),
            React.createElement("div", { className: "c-document__card-status" },
                React.createElement("div", { className: "c-document__sign-status" },
                    React.createElement("div", { className: formStatusToIndicatorClass(form.status) }),
                    React.createElement("div", { className: "c-document__sign-status-text" }, formStatusToString(form.status, props.t))),
                React.createElement("div", { className: "c-document__sign-date" }, form.status_date)),
            React.createElement("div", { className: "c-document__card-action" }, renderCardAction(props, form))),
        React.createElement("div", { className: cardPropertiesClasses }, form.properties.map(renderDocumentProperty(props)))));
}; };
exports.renderDocumentCard = renderDocumentCard;
var renderDocumentResult = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "c-document__cards" }, props.isLoading ? (React.createElement("div", { className: "c-document__loading" },
            React.createElement("span", { className: "fal fa-spinner fa-spin" }))) : props.eforms.map(renderDocumentCard(props))),
        ResultPagination_1.renderPagination(props.currentPage, props.totalPage, props.onChangePage, props.resultT)));
};
exports.renderDocumentResult = renderDocumentResult;
var renderDocumentResultHead = function (props) {
    if (!props.eforms || !props.eforms.length)
        return null;
    var PAGE_SIZE = 10;
    var from = (props.currentPage - 1) * PAGE_SIZE + 1;
    var to = props.eforms.length;
    var total = props.totalItems;
    var summaryText = format_1.default.print(props.t.showingRecords, ["" + from, "" + to, "" + total]);
    var onSortLabelClick = function () { return props.onSortLabelClick(); };
    return (React.createElement("div", { className: "c-myprop__resulthead" },
        React.createElement("div", { className: "c-myprop__summary" }, summaryText),
        React.createElement("div", { className: "c-myprop__sort" },
            React.createElement("div", { onClick: onSortLabelClick, className: "c-myprop__sort-label" }, props.t.sortBy),
            React.createElement("div", { className: "c-myprop__sort-panel " + (props.isSortActive ? 'c-myprop__sort-panel--active' : '') },
                React.createElement("div", { className: "c-myprop__sort-panel-title" }, props.t.sortBy),
                React.createElement("div", { className: "c-myprop__sort-panel-options" },
                    React.createElement("div", { onClick: function () { return props.onSortChanged(DocumentSortEnum_1.DocumentSortEnum.SORT_CREATE_DATE_DESC); }, className: "c-myprop__sort-panel-option" }, props.t.sortCreateDateDesc),
                    React.createElement("div", { onClick: function () { return props.onSortChanged(DocumentSortEnum_1.DocumentSortEnum.SORT_CREATE_DATE_ASC); }, className: "c-myprop__sort-panel-option" }, props.t.sortCreateDateAsc),
                    React.createElement("div", { onClick: function () { return props.onSortChanged(DocumentSortEnum_1.DocumentSortEnum.SORT_FORM_TYPE_ASC); }, className: "c-myprop__sort-panel-option" }, props.t.sortFormTypeAsc),
                    React.createElement("div", { onClick: function () { return props.onSortChanged(DocumentSortEnum_1.DocumentSortEnum.SORT_FORM_TYPE_DESC); }, className: "c-myprop__sort-panel-option" }, props.t.sortFormTypeDesc))))));
};
exports.renderDocumentResultHead = renderDocumentResultHead;
var renderLoading = function (props) {
    return (React.createElement("div", { className: "c-document__loading" },
        React.createElement("span", { className: "fal fa-spinner fa-spin" })));
};
exports.renderLoading = renderLoading;
